// src/components/ForgotPasswordForm.jsx
import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const ForgotPasswordForm = () => {
	const [email, setEmail] = useState("");
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);

		try {
			const response = await axios.post(
				"https://bulksms.approot.ng/request_password_reset.php",
				{ email },
				{
					headers: {
						"Content-Type": "application/json",
					},
				}
			);

			if (response.data.status) {
				toast.success(response.data.message || "Password reset link sent.");
			} else {
				toast.error(response.data.message || "Failed to send reset link.");
			}
		} catch (error) {
			console.error("Forgot password error:", error);
			toast.error("An error occurred. Please try again later.");
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className='min-h-screen flex items-center justify-center bg-gray-50 px-4'>
			<div className='w-full max-w-md bg-white p-8 rounded-lg shadow-md font-inter'>
				<h2 className='text-3xl font-semibold text-center text-red-600 mb-6'>
					Forgot Password
				</h2>
				<p className='text-center text-gray-700 mb-6'>
					Enter your email address and we'll send you a link to reset your
					password.
				</p>
				<form onSubmit={handleSubmit} className='space-y-6'>
					<div>
						<label htmlFor='email' className='block text-gray-700 font-medium'>
							Email
						</label>
						<input
							type='email'
							id='email'
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							className='w-full p-3 mt-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500'
							required
						/>
					</div>
					<button
						type='submit'
						disabled={loading}
						className='w-full py-3 mt-4 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed'
					>
						{loading ? "Sending..." : "Send Reset Link"}
					</button>
				</form>
				<div className='mt-4 text-center'>
					<a href='/' className='text-sm text-red-600 hover:underline'>
						Back to Login
					</a>
				</div>
			</div>
		</div>
	);
};

export default ForgotPasswordForm;
